import React from "react";
import {createRoot} from "react-dom/client";
import "./reset.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";
import {RecoilRoot} from "recoil";
import {RootNavigation} from "@navigation";

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <RecoilRoot>
    <BrowserRouter>
      <RootNavigation />
    </BrowserRouter>
  </RecoilRoot>,
);

reportWebVitals();
